import { render } from "./index.vue?vue&type=template&id=32693bbd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32693bbd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32693bbd"],['__file',"src/views/MyAccount/AppointmentHistory/Review/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32693bbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32693bbd', __exports__)) {
    console.log('reload')
    api.reload('32693bbd', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=32693bbd&scoped=true", () => {
    console.log('re-render')
    api.rerender('32693bbd', render)
  })

}


export default __exports__